import { createSelector } from "@ngrx/store";

import * as fromFeature from "../reducers";
import * as fromCartProperties from "../reducers/cart-properties.reducer";

export const getCartPropertiesState = createSelector(
    fromFeature.getCartState,
    (state: fromFeature.CartState) => state.cartProperties
);

export const getAssignCartTabOpen = createSelector(
    getCartPropertiesState,
    fromCartProperties.getAssignCartTabOpen
);

export const getAssignCartOpen = createSelector(
    getCartPropertiesState,
    fromCartProperties.getAssignCartOpen
);

export const getCreatingLesson = createSelector(
    getCartPropertiesState,
    fromCartProperties.getCreatingLesson
);

export const getEditingLesson = createSelector(
    getCartPropertiesState,
    fromCartProperties.getEditingLesson
);

export const getCreatingActivity = createSelector(
    getCartPropertiesState,
    fromCartProperties.getCreatingActivity
);

export const getEditingActivity = createSelector(
    getCartPropertiesState,
    fromCartProperties.getEditingActivity
);

export const getContainsComposite = createSelector(
    getCartPropertiesState,
    fromCartProperties.getContainsComposite
);

export const getLessonFormData = createSelector(
    getCartPropertiesState,
    fromCartProperties.getLessonFormData
);

export const getLessonFormValidity = createSelector(
    getCartPropertiesState,
    fromCartProperties.getLessonFormValidity
);

export const getCustomActivityFormData = createSelector(
    getCartPropertiesState,
    fromCartProperties.getCustomActivityFormData
);

export const getPerformActivityFormData = createSelector(
    getCartPropertiesState,
    fromCartProperties.getPerformActivityFormData
);

export const getActivityFormValidity = createSelector(
    getCartPropertiesState,
    fromCartProperties.getActivityFormValidity
);

export const getProgramSubjectId = createSelector(
    getCartPropertiesState,
    fromCartProperties.getProgramSubjectId
);

export const getProgramEditionId = createSelector(
    getCartPropertiesState,
    fromCartProperties.getProgramEditionId
);

export const getAssetInUse = createSelector(
    getCartPropertiesState,
    fromCartProperties.getAssetInUse
);
